import $ from "jquery";

export class CompanyProfilePublicCarousel {
    static readonly REMAINING_PHOTOS_RENDER_DELAY = 2000;
    readonly companyProfileCarouselId = 'company-profile-public-carousel';
    readonly nextFlipBtnId = 'carousel-next';
    readonly previousFlipBtnId = 'carousel-prev';

    private companyProfileCarousel: JQuery<HTMLElement>;
    private carouselTemplate: HTMLElement;
    private bodyTemplate: HTMLElement;
    private remainingPhotosList: NodeListOf<HTMLElement>;

    public init(): void {
        this.activateCompanyProfileCarousel(this.companyProfileCarouselId);
        this.updatePreviewPhotosList();
    }

    public hideCarousel(element: HTMLElement): void {
        if (this.checkElementId(element)) {
            this.bodyTemplate.classList.remove('hide-scroll-bar');
            this.carouselTemplate.classList.remove('d-block');
            this.carouselTemplate.classList.add('d-none');
        }
    }

    public showCarousel(startImageIndex: number): void {
        this.bodyTemplate.classList.add('hide-scroll-bar');
        this.carouselTemplate.classList.remove('d-none');
        this.carouselTemplate.classList.add('d-block');
        this.companyProfileCarousel.carousel(startImageIndex);

        // Show carousel start slide number
        document.querySelector('#current-image-index').innerHTML = (startImageIndex + 1).toString();
    }

    public nextFlip(): void {
        this.companyProfileCarousel.carousel('next');
    }

    private updatePreviewPhotosList(): void {
        this.remainingPhotosList = document.querySelectorAll('[data-src]');
        if (this.remainingPhotosList.length > 0) {
            setTimeout( () => {
                this.remainingPhotosList.forEach(photo => {
                    photo.setAttribute('src', photo.getAttribute('data-src'));
                    photo.onload = () => photo.classList.remove('preview-loader-padding');
                });
            }, CompanyProfilePublicCarousel.REMAINING_PHOTOS_RENDER_DELAY);
        }
    }

    private activateCompanyProfileCarousel(selector: string): void {
        this.carouselTemplate = document.querySelector(`#${selector}`);
        if (this.carouselTemplate) {
            this.bodyTemplate = document.querySelector('body');
            this.companyProfileCarousel = $(`#${selector}`);
            this.companyProfileCarousel.carousel();
            this.subscribeToCarouselEvents();
        }
    }

    private subscribeToCarouselEvents(): void {
        this.handlePreviousFlip();
        this.handleNextFlip();
        this.handleDisplayingImageNumber();
    }

    private handleDisplayingImageNumber(): void {
        // Subscribe on event after flipping through slides to show selected slide number
        this.companyProfileCarousel.on('slid.bs.carousel', function (slide) {
            document.querySelector('#current-image-index').innerHTML = (slide.to + 1).toString();
        })
    }

    private handlePreviousFlip(): void {
        document.querySelector(`#${this.previousFlipBtnId}`)
            .addEventListener('click', () => {
                this.companyProfileCarousel.carousel('prev');
            })
    }

    private handleNextFlip(): void {
        document.querySelector(`#${this.nextFlipBtnId}`)
            .addEventListener('click', () => {
                this.companyProfileCarousel.carousel('next');
            })
    }

    private checkElementId(element: HTMLElement): boolean {
        return element.id === this.companyProfileCarouselId ||
            element.id === 'carousel-close-button' ||
            element.id === 'carousel-close-icon'
    }
}
